import actionTypes from '../../common/actionTypes';
import pickListApi from './pickListAPI';

const pickListActions = {
	setPickListType: (pickListType: PickListType) => {
		return { type: actionTypes.SET_PICKLIST_TYPE_SUCCESS, pickListType };
	},
	setPickListItem: (pickListItem: PickListItem) => {
		return { type: actionTypes.SET_PICKLIST_ITEM_SUCCESS, pickListItem };
	},
	getPickListType: (id: string) => {
		return (dispatch: any) => {
			return pickListApi.getPickListType(id)
				.then(pickListType => {
					dispatch({ type: actionTypes.GET_PICKLIST_TYPE_SUCCESS, pickListType });
				})
				.catch(error => {
					throw (error);
				});
		};
	},
	getPickListTypes: () => {
		return (dispatch: any) => {
			return pickListApi.getPickListTypes()
				.then(pickListTypes => {
					dispatch({ type: actionTypes.GET_PICKLIST_TYPES_SUCCESS, pickListTypes });
				})
				.catch(error => {
					throw (error);
				});
		};
	},
	getPickListItem: (itemId: string) => {
		return (dispatch: any) => {
			return pickListApi.getPickListItem(itemId)
				.then(pickListItem => {
					dispatch({ type: actionTypes.GET_PICKLIST_ITEM_SUCCESS, pickListItem });
				})
				.catch(error => {
					throw (error);
				});
		};
	},
	getPickListItems: () => {
		return (dispatch: any) => {
			return pickListApi.getPickListItems()
				.then(pickListItems => {
					dispatch({ type: actionTypes.GET_PICKLIST_ITEMS_SUCCESS, pickListItems });
				})
				.catch(error => {
					throw (error);
				});
		};
	},
	savePickListType: (type: PickListType) => {
		return (dispatch: any) => {
			return pickListApi.savePickListType(type)
				.then(pickListType => {
					dispatch({ type: actionTypes.SAVE_PICKLIST_TYPE_SUCCESS, pickListType });
				});
		};
	},
	savePickListItem: (item: PickListItem) => {
		return (dispatch: any) => {
			return pickListApi.savePickListItem(item)
				.then(pickListItem => {
					dispatch({ type: actionTypes.SAVE_PICKLIST_ITEM_SUCCESS, pickListItem });
				});
		};
	}
};

export default pickListActions;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/PickList/pickListActions.ts